'use client';
import { Audiotrack, Slideshow } from '@mui/icons-material';
import { Alert, Box, Paper, Typography } from '@mui/material';
import AudioPlayer from '@/components/shared/audio-player';
import ReportContentButton from '@/components/shared/report-content-button';
import RichContent from '@/components/shared/rich-content';
import VideoPlayer from '@/components/shared/video-player';
import { useReportContent } from '@/hooks';
import { useViewStore } from '@/stores';
import type { Unit as UnitModel } from '@/types';

export default function Unit({ unit }: { unit: UnitModel }) {
  const { id, audioUrl, contentNode, summaryNode, videoUrl } = unit;
  const { reportContent, shouldShow } = useReportContent();
  const { showChapterNote } = useViewStore();

  return (
    <Box
      sx={{
        width: 'inherit',
        pb: 10,
        userSelect: 'none',
      }}>
      {summaryNode && (
        <Paper variant="outlined" sx={{ mb: 3, p: 3 }}>
          <Typography variant="h2" sx={{ mb: 1 }}>
            Zusammenfassung des Kapitels
          </Typography>
          <RichContent content={summaryNode} />
        </Paper>
      )}
      {videoUrl && (
        <>
          <Alert icon={<Slideshow />} severity="info" sx={{ mb: 1 }}>
            Du kannst dieses Kapitel im Video ansehen
          </Alert>
          <Box sx={{ mb: 3 }}>
            <VideoPlayer url={videoUrl} />
          </Box>
        </>
      )}
      {audioUrl && (
        <>
          <Alert icon={<Audiotrack />} severity="info" sx={{ mb: 1 }}>
            Du kannst dieses Kapitel anhören
          </Alert>
          <Box sx={{ mb: 3 }}>
            <AudioPlayer url={audioUrl} />
          </Box>
        </>
      )}
      <RichContent content={contentNode} />
      <ReportContentButton
        entityId={id}
        entityType="Unit"
        onReport={reportContent}
        show={shouldShow && !showChapterNote}
      />
    </Box>
  );
}
